export const middlePageHooks = {
  "subpos":{
    "share_article": {
      "header_banner": {
        "text":"${navActionText}${APPName}，阅读体验更佳"
      },
      "readmore": {
        "text":"去APP阅读参与评论互动"
      },
      "hot_topics": {},
      "recommend": {},
      "bottom_banner": {},
      "twice_share_modal": {}
    },
    "share_short_video": {
      "header_banner": {},
      "cover_play_btn": {
        "text":"${navActionText}${APPName}<br/>与上亿网友互动看神评"
      },
      "video_pause_btn": {
        "text":"精彩之处稍作休息，<br/>去${APPName}看更多神片儿！"
      },
      "video_end_btn": {
        "text":"看完还不过瘾，<br/>更多精彩在${APPName}等您！"
      },
      "bottom_banner": {},
      "twice_share_modal": {}
    },
    "share_mini_video": {
      "cover_play_btn": {
        "text":"${navActionText}${APPName}<br/>与上亿网友互动看神评"
      },
      "video_pause_btn": {
        "text":"精彩之处稍作休息，去${APPName}<br/>看更多神片儿！"
      },
      "video_end_btn":{},
      "recommend": {
        "text":"合辑 ${navActionText}${APPName}查看"
      },
      "recommend_list": {},
      "twice_share_modal": {}
    }
  },
  "pageUrl": window.location.href.indexOf('sparta') > -1 ?
    "https://upage.imtt.qq.com/m_imtt/download-middle-page/temp/download_middle_page.html?type=${type}&subpose=${subpose}&stat=${stat}&vconsole=true"
    :
    "https://upage.imtt.qq.com/m_imtt/download-middle-page/real/download_middle_page.html?type=${type}&subpose=${subpose}&stat=${stat}"
}
export const endContentConfig = {
  "news":{
    "news":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123239"
    },
    "video":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123238"
    },
    "miniVideo":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123237"
    }
  },  
  "novel":{
    "news":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100121858"
    },
    "video":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100121859"
    },
    "miniVideo":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100121860"
    }
  },
  "search":{
    "news":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100122451"
    },
    "video":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100122960"
    },
    "miniVideo":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100122961"
    }
  },
  "welfare":{
    "news":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123606"
    },
    "video":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123607"
    },
    "miniVideo":{
      "qbDownlodUrl":"https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100123608"
    }
  },
}